<template>
  <div id="step11" class="flex">
    <div class="flex invoice-wrapper oval relative">
      <transition name="fade">
        <loading v-if="loading" />
      </transition>

      <div class="left relative">
        <div class="flex-column align-end sub-titles">
          <h4>
            <span class="block capitalize text-right">見積もり番号</span>
            <span class="block uppercase text-right">{{randomInt}}</span>
          </h4>
          <h4 class="date">
            <span class="block capitalize text-right">日付</span>
            <span class="block uppercase text-right">{{todayDate()}}</span>
          </h4>
        </div>
        <div class="r-body">
          <button class="copy uppercase pointer transition relative" @click="linkCopy()">
            <span v-show="copyed" id="copyed">コピーしました</span>
            <span>結果リンクをコピー</span>
          </button>
          <button class="pdf uppercase pointer transition relative" @click="createCanvas()">
            <span class="pdf block uppercase">pdf</span>
            <span>ダウンロード</span>
          </button>
        </div>
        <h2>シミュレーション結果</h2>
        <right-content />
      </div>

      <div class="right">
        <div class="flex r-hdr">
          <div class="main-title">
            <h2 class="uppercase">
              お見積もり
              <img src="../assets/images/logo.png" alt="logo">
            </h2>
          </div>
        </div>

        <div class="r-body">
          <ul class="results flex-column align-center overflow-y custom-sb">
            <li v-for="id in 10" :key="id" class="flex align-center justify-start result-item">
              <div v-if="findStep(id)" class="flex align-center wrapper relative">
                <span class="flex align-center pointer" @click="pushTo('Step'+id, route.query)"><i class="fas fa-chevron-left"></i> {{id}}. {{findStep(id).stepJp}}</span>
                <span class="flex-column align-center">
                  <span>{{id !== 10 ? findStep(id).name : ringSizeResult(findStep(id).val)}}</span>
                  <span v-if="findStep(id).hasOwnProperty('option')">
                    {{id === 7 && findStep(id).option ? ", ダイヤの色: " + diamondJName(findStep(id).option) : 
                      id === 7 && !findStep(id).option && findStep(id).tab == 1 && !['taiyoboriBase','hoshiboriBase'].includes(findStep(id).val) ? ", ダイヤの色: 透明" :
                      id === 9 && findStep(id).option ? ", 文字: " + findStep(id).option : ""}}
                  </span>
                </span>
                <span class="absolute price">{{ priceArray[id-1] == "0" ? "-" : "¥ "+priceSeparate(priceArray[id-1]) }}</span>
              </div>
              <div v-if="!findStep(id)" class="flex wrapper relative">
                <span class="flex align-center pointer" @click="pushTo('Step'+id, route.query)"><i class="fas fa-chevron-left"></i> {{id}}. {{id === 6 ? "ミルグレイン" : id === 7 ? "外側ダイヤ" : id === 8 ? "内石" : id === 9 ? "刻印" : ""}}</span>
                <span class="flex align-center">なし</span>
                <span class="absolute price">{{ priceSeparate(priceArray[id-1]) }}</span>
              </div>
            </li>
            <li class="flex-wrap align-center last">
              <span class="block" v-if="totalPriceFormatter">（税抜合計　{{ priceSeparate(totalPriceFormatter) }} 円）</span>
              <span class="block" v-if="totalPriceAddTax">税込合計　{{ priceSeparate(totalPriceAddTax) }} 円</span>
            </li>
          </ul>
          
          
        </div>
        <div class="r-body-sm">
            <button class="copy uppercase pointer transition relative" @click="linkCopy()">
              <span v-show="copyed" id="copyed">コピーしました</span>
              <span>結果リンクをコピー</span>
            </button>
            <button class="pdf uppercase pointer transition relative" @click="createCanvas()">
              <span class="pdf block uppercase">pdf</span>
              <span>ダウンロード</span>
            </button>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import {computed, ref} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import useRoutePush from "@/modules/moduleA/helpers/useRoutePush";
import usePDFHandler from "@/modules/moduleA/helpers/usePDFHandler";
import RightContent from "@/modules/moduleA/components/contents/RightContent";
import Loading from "@/components/Loading";
import useResultsPriceArray from "@/modules/moduleA/helpers/useResultsPriceArray";
import html2canvas from 'html2canvas';

export default {
  name: "Step11",
  components: {Loading, RightContent},
  setup(){
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const {pushTo} = useRoutePush()
    const results = computed(() => {
      return store.state.moduleA.results
    })
    const copyed = ref(false);
    
    const {priceArray} = useResultsPriceArray()

    store.commit("setCanvasImg", null)
    const createCanvas = () => {
      const img = document.getElementById("rightContent")
      const target = document.getElementById("baseColorImg")
      const targetD = document.getElementById("diaColorImg")
      const targetR = document.getElementById("rightContent")
      const targetI = document.getElementById("insideDiaColorImg")
      const targetG = document.getElementById("insideDiaGrayImg")
      target.style.display = 'none'
      if(targetD !== null){
        targetD.style.display = 'none'
      }
      if(targetI !== null){
        targetI.style.display = 'none'
        targetG.style.display = 'block'
      }
      targetR.classList.add("gray")
      html2canvas(img).then(canvas => {
        store.commit("setCanvasImg", canvas.toDataURL("image/png"))
      })
      .then(function(){
        makePDF()
      })
      .then(function(){
        target.style.display = 'block';
        if(targetD !== null){
          targetD.style.display = 'block';
        }
        if(targetI !== null){
          targetI.style.display = 'block'
          targetG.style.display = 'none'
        }
        targetR.classList.remove("gray");
      });
    }

    const {makePDF} = usePDFHandler()


    const linkCopy = () => {
      const target = document.getElementById("copyed")
      target.classList.add('fade');
      copyed.value = true
      setTimeout(() => {
        copyed.value = false
        target.classList.remove('fade');
      }, 2000);

      var text = location.href;
      //textareaを生成
      var area = document.createElement("textarea");
      //p要素の内容をtextareaに記述
      area.textContent = text;
      //生成したものをdocumentに追加
      document.body.appendChild(area);
      //選択/コピーして・・
      area.select();
      document.execCommand("copy");
      //すぐに消す。
      document.body.removeChild(area);
    }



    const loading = ref(true)


    setTimeout( () => {
      loading.value = false
    }, 1000)

    const findStep = (id) => {
      return results.value.find(item => {
        return item.step === id
      })
    }

    // 金額を3桁でコンマ
    function priceSeparate(num){
        return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }
    
    const totalPriceFormatter = computed(() => {
      return priceArray.reduce((sum, element) => sum + element, 0);
    })

    const totalPriceAddTax = computed(() => {
      return  Math.floor(priceArray.reduce((sum, element) => sum + element, 0) * 1.1);
    })

    //step 10 ring size to japanese
    const ringSizeResult = (val) => {
      if(val == "00") {
        return "不明（12.5号以下）"
      }else if(val == "99") {
        return "不明（13号以上）"
      }else{
        return "#"+val
      }
    }

    //step 7 diamond name to japanese 
    const diamondJName = (val) => {
      if (val == 'transparent'){
        return '透明'
      }else if (val == 'brown'){
        return 'ブラウン'
      }else if (val == 'black'){
        return 'ブラック'
      }else if (val == 'blue'){
        return 'ブルー'
      }else{
        return ''
      }
    }

    // today's date
    const todayDate = () => {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth()+1;
      const day = today.getDate();
      return year + "/" + month+ "/" + day
    }


    // make mitumori id
    function makeMitumoriId(){
      return new Promise((resolve, reject) => {
        // クエリから性別を判断する
        const queryStr = window.location.search.slice(1),  // 文頭?を除外
              queries = {};
        // クエリ文字列を & で分割して処理
        queryStr.split('&').forEach(function(queryStr) {
          // = で分割してkey,valueをオブジェクトに格納
          let queryArr = queryStr.split('=');
          queries[queryArr[0]] = queryArr[1];
        });
        let genderMark = "";
        Object.keys(queries).forEach((key) =>{
          if(key === "gender" && queries[key] === "man") {
            genderMark = "M-"
          }else if(key === "gender" && queries[key] === "woman") {
            genderMark = "F-"
          };
        })
        const data = genderMark + (Math.floor(Math.random() * (1999999 + 1 - 1000000)) + 1000000).toString();
        resolve(data)
        reject(false)
      })
    }

    const randomInt = ref(null)
    makeMitumoriId().then(response => {
      if(response){    
        randomInt.value = response
        const userIdObj = {userId: response}
        const query = {...route.query, ...userIdObj}
        router.replace({query: query})
      }
    })



    return {route, pushTo, findStep, loading,
            createCanvas, priceArray, totalPriceFormatter,totalPriceAddTax,
            ringSizeResult,diamondJName, priceSeparate, todayDate, randomInt, linkCopy, copyed}
  }
}
</script>
<style scoped>
.invoice-wrapper {
  font-family: 'Noto Sans JP', sans-serif;
  height: calc(100% - 50px);
  width: 100%;
  padding: 10px 40px;
  margin-top: 10px;
  border: 7px solid white;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, .2);
  /*background-color: #dcdde1;*/
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  -ms-flex-direction: row-reverse;
  flex-direction: row-reverse;
}
.invoice-wrapper > .left,
.invoice-wrapper > .right {
  height: 100%;
}
.invoice-wrapper > .left {
  width: 300px;
  min-width: 300px;
  max-width: 300px;
  /* padding-top: 200px; */
}
.invoice-wrapper > .left > h2 {
  font-weight: 300;
  font-size: .9rem;
  color: #5b5b5d;
  padding-left: 10px;
}
.invoice-wrapper > .left > #rightContent {
  width: 100%;
  justify-content: flex-start;
  margin-top: 10px;
  height: auto;
}


.invoice-wrapper > .right {
  width: calc(100% - 320px);
  /* width: 80%; */
  border-left: 1px solid #f3f3f3;
  padding-left: 20px;
  margin-left: 20px;
  height: 100%;
  margin: auto;
}
.invoice-wrapper > .right > .r-hdr {
  height: auto;
}
.invoice-wrapper > .right > .r-hdr > .main-title {
  padding-top: 24px;
}
/* .invoice-wrapper > .right > .r-hdr > .main-title{
  width: 65%;
} */
.invoice-wrapper > .left > .sub-titles {
  width: 40%;
  margin-left: auto;
  margin-bottom: 40px;
}
.invoice-wrapper > .right > .r-hdr > .main-title > h2 {
  font-size: 2.2rem;
  font-weight: 400;
  color: #5b5b5d;
  /* font-family: EB Garamond,Ryumin Regular KL,游明朝,YuMincho,Hiragino Mincho ProN,Meiryo,serif; */
  letter-spacing: 0.1rem;
  width: 90%;
  /* margin-left: auto; */
}
.invoice-wrapper > .right > .r-hdr > .main-title > h2 > img {
  position: relative;
  top: -10px;
  height: 26px;
}
.invoice-wrapper > .left > .sub-titles > h4:first-child {
  margin-top: 0px;
}
.invoice-wrapper > .left > .sub-titles > h4 {
  padding: 5px 0;
  font-weight: 300;
  font-size: .8rem;
}
.invoice-wrapper > .left > .sub-titles > h4.date {
  margin-top: 10px;
  padding-bottom: 0;
  padding-top: 0;
}
.invoice-wrapper > .left > .sub-titles > h4 > span:last-child  {
  font-weight: 500;
  font-size: .85rem;
}


.invoice-wrapper > .right > .r-body {
  height: calc(100% - 145px);
}
.invoice-wrapper > .right > .r-body > ul.results {
  list-style-type: none;
  margin: 0;
  border-top: 2px solid #22252f;
  padding-left: 0;
  height: calc(100% - 10px);
}
.invoice-wrapper > .right > .r-body > ul.results > li.result-item {
  height: auto;
  min-height: 44px;
  border-bottom: 1px solid #dcdde1;
}
.invoice-wrapper > .right > .r-body > ul.results > li.result-item:hover {
  background-color: #f3f3f3;
}
.invoice-wrapper > .right > .r-body > ul.results > li.result-item,
.invoice-wrapper > .right > .r-body > ul.results > li.result-item > .wrapper {
  width: 100%;
}
.invoice-wrapper > .right > .r-body > ul.results > li.result-item > .wrapper > span {
  font-size: .8rem;
}
.invoice-wrapper > .right > .r-body > ul.results > li.result-item > .wrapper > span:nth-child(1) {
  width: 125px;
  padding-left: 5px;
  color: #5b5b5d;
  border-right: 1px solid #c8c8c9;
}
.invoice-wrapper > .right > .r-body > ul.results > li.result-item > .wrapper > span:nth-child(1) > i {
  position: relative;
  top: 1px;
  margin-right: 8px;
}
.invoice-wrapper > .right > .r-body > ul.results > li.result-item > .wrapper > span:nth-child(2) {
  display: block;
  align-items: flex-start;
  padding-left: 14px;
}
.invoice-wrapper > .right > .r-body > ul.results > li.result-item > .wrapper > span.price {
  display: block;
  right: 10px;
  width: auto;
  border-bottom: 1px solid #22252f;
  text-align: right;
}
.invoice-wrapper > .right > .r-body > ul.results > li.last {
  margin-top: 10px;
  width: 100%;
  /* height: 70px;
  min-height: 70px; */
  border-radius: 14px;
  /* background-color: #f3f3f3; */
}
.invoice-wrapper > .right > .r-body > ul.results > li.last > span:nth-child(1) {
  width: 280px;
  padding-top: 5px;
  /* padding-left: 14px; */
  /* color: #5b5b5d; */
  font-size: 1.3rem;
}
.invoice-wrapper > .right > .r-body > ul.results > li.last > span:nth-child(2) {
  width: calc(100% - 300px);
  padding-left: 5px;
  font-size: 1.3rem;
  /* color: rgb(131, 179, 173); */
}

/*Styles for second pair of buttons
-------------------------------------------------------------
*/

.invoice-wrapper > .right > .r-body-sm > button.pdf  {
  right: 2px;
  bottom: 2px;
  border: 2px solid #2f313d;
  width: 120px;
  height: 36px;
  border-radius: 10px;
  font-size: .8rem;
  margin: 20px 0px;
}
.invoice-wrapper > .right > .r-body-sm > button.pdf > span {
  position: relative;
  z-index: 2;
}
.invoice-wrapper > .right > .r-body-sm > button.pdf > span.pdf {
  position: absolute;
  top: 50%;
  opacity: .6;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.7rem;
  color: #dcdde1;
  z-index: 1;
  font-weight: 600;
}
.invoice-wrapper > .right > .r-body-sm > button.pdf:hover  {
  border-color: white;
  color: white;
  background-color: #22252f;
}
.invoice-wrapper > .right > .r-body-sm > button.pdf:hover > span.pdf  {
  color: #2f313d;
}

.invoice-wrapper > .right > .r-body-sm > button.copy  {
  right: 10px;
  bottom: 2px;
  border: 2px solid #2f313d;
  width: 160px;
  height: 36px;
  border-radius: 10px;
  font-size: .8rem;
  margin: 10px 0px;
}
.invoice-wrapper > .right > .r-body-sm > button.copy:hover  {
  border-color: white;
  color: white;
  background-color: #22252f;
}

.invoice-wrapper > .right > .r-body-sm {
    display:none;
}
/* END second button 
--------------------------------------------------------------
*/

.invoice-wrapper > .left > .r-body > button.pdf  {
  position: absolute;
  right: 2px;
  bottom: 2px;
  border: 2px solid #2f313d;
  width: 120px;
  height: 36px;
  border-radius: 10px;
  font-size: .8rem;
}
.invoice-wrapper > .left > .r-body > button.pdf > span {
  position: relative;
  z-index: 2;
}
.invoice-wrapper > .left > .r-body > button.pdf > span.pdf {
  position: absolute;
  top: 50%;
  opacity: .6;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.7rem;
  color: #dcdde1;
  z-index: 1;
  font-weight: 600;
}
.invoice-wrapper > .left > .r-body > button.pdf:hover  {
  border-color: white;
  color: white;
  background-color: #22252f;
}
.invoice-wrapper > .left > .r-body > button.pdf:hover > span.pdf  {
  color: #2f313d;
}

.invoice-wrapper > .left > .r-body > button.copy  {
  position: absolute;
  right: 140px;
  bottom: 2px;
  border: 2px solid #2f313d;
  width: 160px;
  height: 36px;
  border-radius: 10px;
  font-size: .8rem;
}
.invoice-wrapper > .left > .r-body > button.copy:hover  {
  border-color: white;
  color: white;
  background-color: #22252f;
}

.invoice-wrapper #copyed {
  color: #222 !important;
  position: absolute;
  top: -20px;
  font-size: .8rem;
}
.invoice-wrapper #copyed.fade {
  animation: fade 1.5s forwards;
}
@keyframes fade{
  0%{opacity:0;}
  75%{opacity:1;transform: translateY(-10px);}
  100%{opacity: 0;transform: translateY(-10px);}
}

@media screen and (max-width: 1100px),
       screen and (max-height:716px){
  .invoice-wrapper > .right {
    padding-right: 10px;
  }
  .invoice-wrapper > .left > .sub-titles {
    margin-bottom: 15px;
  }
  .invoice-wrapper > .left > .r-body > button.pdf  {
    width: 110px;
    height: 32px;
  }
  .invoice-wrapper > .left > .r-body > button.copy  {
    width: 155px;
    height: 32px;
  }
  .invoice-wrapper > .left > #rightContent {
    width: 85%
  }  
}
@media screen and (max-height:650px){
    .invoice-wrapper > .left > #rightContent {
    width: 65%
  } 
}

@media screen and (max-width: 866px),
        screen and (max-height: 614px){
  .invoice-wrapper {
    flex-direction: column;
    width: 95%;
    margin: auto;
    height: calc(100% - 20px);
    overflow-y: scroll;
    padding: 10px 20px 0 10px;
  }
  .invoice-wrapper > .left  {
    padding: 0;
    max-width: 100%;
    width: 100%;
    max-width: 400px;
    margin:0 auto 20px;
  }

  .invoice-wrapper > .left > .sub-titles {
    width: 100%;
    margin-bottom: 0px;
    flex-direction: row;
    align-items: baseline;
    justify-content: flex-end;
  }
  .invoice-wrapper > .left > .sub-titles > h4 {
      margin-left: 15px;
  }

  /* .invoice-wrapper > .left > #rightContent {
    height: 250px;
  } */


  .invoice-wrapper > .right {
    width: 92%;
    border: none;
    margin: auto;
    padding: 0 0 20px;
  }
  .invoice-wrapper > .right > .r-hdr {
    margin-bottom: 10px;
  }
  .invoice-wrapper > .right > .r-hdr > .main-title > h2 {
    font-size: 2.0rem;
    font-weight: 400;
    color: #5b5b5d;
    width: auto;
    letter-spacing: 0;
  }
  .invoice-wrapper > .right > .r-hdr > .main-title > h2 > img {
    top: 0px;
  }
  .invoice-wrapper > .right > .r-hdr > .sub-titles {
    width: 50%;
  }
  .invoice-wrapper > .right > .r-body > ul.results {
    list-style-type: none;
    margin: 0;
    border-top: 2px solid #22252f;
    padding-left: 0;
    height: 100%;
    padding-bottom: 20px;
  }
  .invoice-wrapper > .left > .r-body > button.pdf {
    position: relative;
    margin-top: 30px;
    margin-bottom: 40px;
  }
  .invoice-wrapper > .left > .r-body > button.copy {
    position: relative;
    margin-top: 30px;
    margin-bottom: 40px;
    right: auto;
    margin-right: 20px;
  }

  .invoice-wrapper > .right > .r-body > ul.results > li.result-item > .wrapper {
    align-items: flex-start;
  }
  .invoice-wrapper > .right > .r-body > ul.results > li.result-item > .wrapper > span:nth-child(2) {
    width: 40%;
    display: block;
    align-items: flex-start;
  }
  .invoice-wrapper > .right > .r-body > ul.results > li.result-item > .wrapper > span > span {
  }

  .invoice-wrapper > .right > .r-body > ul.results > li.last > span:nth-child(1) {
    width: 100%;
    font-size: 1.0rem;
  }
  .invoice-wrapper > .right > .r-body > ul.results > li.last > span:nth-child(2) {
    width: 100%;
    font-size: 1.1rem;
  }


  /* Toggle visible buttons on small sizes*/
  .invoice-wrapper > .left > .r-body{
    display:none;
  }
  .invoice-wrapper > .right > .r-body-sm {
    display:unset;
  }
  /* ------------------------------------- */
}

@media screen and (max-width: 321px) {
  .invoice-wrapper > .right > .r-body > ul.results > li.result-item > .wrapper {
    flex-wrap: wrap;
    align-items: flex-end;
  }
  .invoice-wrapper > .right > .r-body > ul.results > li.result-item > .wrapper > span:nth-child(1) {
    width: 100%;
  }
  .invoice-wrapper > .right > .r-body > ul.results > li.result-item > .wrapper > span:nth-child(2) {
    width: 50%;
  }
  .invoice-wrapper > .right > .r-body > ul.results > li.result-item > .wrapper > span.price {
      width: 40%;
      border-bottom: none;
  }
}



</style>
